// jQuery free
import {onDOMReady} from './dom';

const QUERY_SELECTIVE_SUPPLY_OPTION = '.productDetailAddToCart__supplyOption.--selective';
const CLASS_CURRENT = '--current';
const ID_FORM = 'productDetailAddToCart__form';
const ID_SELECT = 'productDetailAddToCart__supplyOptionSelect';
const DATA_INIT = 'data-init';
const DATA_PRICE_WITH_VAT = 'data-price-with-vat';
const DATA_PRICE_WITHOUT_VAT = 'data-price-without-vat';
const DATA_DISCOUNT_PRICE = 'data-discount-price';
const DATA_STRIKETHROUGH_PRICE = 'data-strikethrough-price';
const DATA_IS_DISPLAYED_WITHOUT_VAT = 'data-is-displayed-without-vat';
const DATA_REFUNDABLE_DEPOSIT_PRICE_WITH_VAT = "data-refundable-deposit-price-with-vat";
const QUERY_STICKY_ADD_TO_CART = '[data-product-detail-sticky-add-to-cart]';
const QUERY_STICKY_PRICE = '[data-product-detail-sticky-add-to-cart-price] .price__primary';
const QUERY_STICKY_AVAILABILITY = '[data-product-detail-sticky-add-to-cart-availability]';


let formElement;
let selectElement;
let supplyIdInputElement;
let stickyAddToCartElement;
const supplyOptionElements = [];


const initSupplyOption = function (supplyOptionElement) {
    if (supplyOptionElement.hasAttribute(DATA_INIT)) {
        return;
    }

    updateSpecialInfo(
        supplyOptionElement.getAttribute(DATA_REFUNDABLE_DEPOSIT_PRICE_WITH_VAT)
    );
    supplyOptionElement.setAttribute(DATA_INIT, '1');
    supplyOptionElements.push(supplyOptionElement);
    if (supplyOptionElement.hasAttribute('disabled')) {
        return;
    }

    supplyOptionElement.addEventListener('click', (event) => {
        event.preventDefault();
        supplyIdInputElement.value = supplyOptionElement.getAttribute('data-value');
        rerenderSupplyOptions();
        updateProductPrice(
            supplyOptionElement.getAttribute(DATA_PRICE_WITH_VAT),
            supplyOptionElement.getAttribute(DATA_PRICE_WITHOUT_VAT),
            supplyOptionElement.getAttribute(DATA_DISCOUNT_PRICE),
            supplyOptionElement.getAttribute(DATA_STRIKETHROUGH_PRICE),
            supplyOptionElement.getAttribute(DATA_IS_DISPLAYED_WITHOUT_VAT)
        );

        updateSpecialInfo(
            supplyOptionElement.getAttribute(DATA_REFUNDABLE_DEPOSIT_PRICE_WITH_VAT)
        );
        updateStickyAvailability(supplyOptionElement);
    });
};


const initSelectElement = function (selectElement) {
    if (selectElement.hasAttribute(DATA_INIT)) {
        return;
    }
    selectElement.setAttribute(DATA_INIT, '1');

    supplyIdInputElement.value = selectElement.value;

    selectElement.addEventListener('change', () => {
        supplyIdInputElement.value = selectElement.value;
    });
};


const updateProductPrice = function (priceWithVat, priceWithoutVat, discountPrice, strikethroughPrice, isDisplayedWithoutVat) {
    const withVatElement = document.querySelector('.--yourPrice .price__primary');
    const withoutVatElement = document.querySelector('.--nonPreferred .price__primary');
    const discountElement = document.querySelector('.--youSave .price__primary');
    const strikethroughElement = document.querySelector('.--strikethrough .price__primary');

    if (withVatElement && priceWithVat) {
        withVatElement.innerHTML = isDisplayedWithoutVat ? priceWithoutVat : priceWithVat;
    }

    if (withoutVatElement && priceWithoutVat) {
        withoutVatElement.innerHTML = isDisplayedWithoutVat ? priceWithVat : priceWithoutVat;
    }

    if (discountElement && discountPrice) {
        discountElement.innerHTML = discountPrice;
    }

    if (strikethroughElement && strikethroughPrice) {
        strikethroughElement.innerHTML = strikethroughPrice;
    }

    const stickyPriceElement = document.querySelector(QUERY_STICKY_PRICE);
    if (stickyPriceElement && priceWithVat) {
        stickyPriceElement.innerHTML = isDisplayedWithoutVat ? priceWithoutVat : priceWithVat;
    }
};


const updateSpecialInfo = function (refundableDepositPriceWithVat) {
    const refundableDepositElement = document.querySelector('.productSpecialInfo.--detail.--refundabledeposit');
    if (!refundableDepositElement) {
        return;
    }

    const refundableDepositPriceElement = refundableDepositElement.querySelector('.price__primary');

    refundableDepositElement.style.display = refundableDepositPriceWithVat ? 'flex' : 'none';

    if(refundableDepositPriceElement && refundableDepositPriceWithVat) {
        refundableDepositPriceElement.innerHTML = refundableDepositPriceWithVat;
    }
};


const updateStickyAvailability = function (supplyOptionElement) {
    const stickyAvailabilityElement = document.querySelector(QUERY_STICKY_AVAILABILITY);
    const availabilityElement = supplyOptionElement.querySelector('[data-product-detail-sticky-availability-template]');
    if (stickyAvailabilityElement && availabilityElement) {
        stickyAvailabilityElement.innerHTML = availabilityElement.innerHTML;
    }
};


const initStickyAddToCart = function () {
    stickyAddToCartElement = document.querySelector(QUERY_STICKY_ADD_TO_CART);
    const submitButtonElement = formElement.querySelector('[type=submit]');
    if (!stickyAddToCartElement || !submitButtonElement) {
        return;
    }

    document.body.append(stickyAddToCartElement);

    const observer = new IntersectionObserver(([entry]) => {
        const isVisible = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        stickyAddToCartElement.classList.toggle('--visible', isVisible);
        stickyAddToCartElement.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    });
    observer.observe(submitButtonElement);
};



const rerenderSupplyOptions = function () {
    for (const supplyOptionElement of supplyOptionElements) {
        const dataValue = supplyOptionElement.getAttribute('data-value');
        if (dataValue !== null && supplyIdInputElement.value.toString() === dataValue.toString()) {
            supplyOptionElement.classList.add(CLASS_CURRENT);
        } else {
            supplyOptionElement.classList.remove(CLASS_CURRENT);
        }
    }
};


onDOMReady(function () {
    formElement = document.getElementById(ID_FORM);
    if (!formElement) {
        return;
    }

    initStickyAddToCart();

    supplyIdInputElement = formElement.querySelector('[name=supplyId]');
    if (!supplyIdInputElement) {
        return;
    }
    selectElement = document.getElementById(ID_SELECT);

    for (const supplyOptionElement of document.querySelectorAll(QUERY_SELECTIVE_SUPPLY_OPTION)) {
        initSupplyOption(supplyOptionElement);
    }

    if (selectElement) {
        initSelectElement(selectElement);
    }

    window.addEventListener('message', (event) => {
        if (!event.data || event.data.type !== 'kvik_addToCart') {
            return;
        }
        const prevSupplyId = supplyIdInputElement.value;
        supplyIdInputElement.value = event.data.supplyId;
        kvik_ajax.sendRequestFromElement(formElement);
        supplyIdInputElement.value = prevSupplyId;
    });
});
